import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 8,
    type: CHECKLIST_ITEM_TYPE.SMS_SENT,
    manifestKey: 'SMS_SENT',

    try_it: {
        // No FE SMS composer exists — only mark-sent-manually path works.
        button_label: 'SMS composer not implemented',
        cell_component_import: null,
        prefill: {
            completion_state: 'YES',
            response_payload: { sent_manually: true },
        },
    },
    pre_flight_diff: [
        '⚠ FE composer missing — only Mark-Sent-Manually path works',
        'BE endpoint is complete and functional',
        'mark-sent-manually: POST /checklist/{iid}/mark-sent-manually/',
        'Checklist item: PENDING → YES with completion_method=manual',
        'Out-of-scope ticket #7 — SMS FE composer',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
